import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFacebookF,
  faInstagram,
  faLinkedinIn,
} from '@fortawesome/free-brands-svg-icons';

const SOCIAL_LINKS = [
  { name: 'Facebook', url: 'https://facebook.com', icon: faFacebookF },
  { name: 'Instagram', url: 'https://instagram.com', icon: faInstagram },
  { name: 'LinkedIn', url: 'https://linkedin.com', icon: faLinkedinIn },
] as const;

export function SocialLinks() {
  return (
    <div className="flex flex-col gap-3 items-start" role="list" aria-label="Connect with us on social media">
      {SOCIAL_LINKS.map(({ name, url, icon }) => (
        <a
          key={name}
          href={url}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-sm text-gray-300 hover:text-white active:text-white transition-colors duration-200 min-h-[44px] focus:outline-none focus:ring-0"
          aria-label={`Follow us on ${name}`}
        >
          <FontAwesomeIcon
            icon={icon}
            className="w-7 h-7 text-inherit flex-shrink-0"
            aria-hidden
          />
          <span>{name}</span>
        </a>
      ))}
    </div>
  );
}
